/*
These functions make sure WordPress
and Foundation play nice together.
*/

$j(document).ready(function() {
	
    // Remove empty P tags created by WP inside of Accordion and Orbit
    $j('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	$j('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  $j(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  $j(this).wrap("<div class='responsive-embed'/>");
		}
	});
}); 